export const EMBEDDED_OAUTH_POPUP_HANDOFF_FLAG = 'ecomm.social-login.fix-embedded-iframe-popup.rollout';
